export const cleanParams = (params: any) => {
  const cleanedParams = params;

  Object.keys(cleanedParams).forEach((key) => {
    const value = cleanedParams[key];
    if (value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) {
      delete cleanedParams[key];
    }
  });

  return cleanedParams;
};
